import React from 'react';
import {FixtureStatus} from "../models/api/codegen/code";
import {useNavigate} from "react-router-dom";
import {Mobile} from "../components/adaptive/Mobile";
import {Desktop} from "../components/adaptive/Desktop";

type CompetitionWrapperProps = {
    fixtureId: number
    fixtureStatus: FixtureStatus
    element: React.ReactElement
}

export const CompetitionWrapper = (props: CompetitionWrapperProps) => {
    const push = useNavigate();
    const {element, fixtureId, fixtureStatus} = props;
    const isLive = fixtureStatus === 'LIVE';
    const handleClickDesktop = () => {
        if (isLive) {
            push("/sport/live/event/" + fixtureId)
        }
    };

    const handleClickMobile = () => {
        if (isLive) {
            push("/sport/mobile/live/event/" + fixtureId)
        }
    };
    return (<>
        <Mobile>
            <div className={isLive ? "cursor-pointer" : "cursor-not-allowed"} onClick={handleClickMobile}>{element}</div>
        </Mobile>
        <Desktop>
            <div className={isLive ? "cursor-pointer" : "cursor-not-allowed"} onClick={handleClickDesktop}>{element}</div>
        </Desktop>
    </>)
};

